import questionSucces from "../animationSounds/question_success.mp3";
import questionFailure from "../animationSounds/question_wrong.mp3";
export function playAnimationSound(name, status) {
  let audioSourceFile = "";
  if (name === "validation") {
    console.log("validation");
    if (status) {
      audioSourceFile = questionSucces;
    } else {
      audioSourceFile = questionFailure;
    }
  }
  let audio = new Audio(audioSourceFile);
  audio.play();
}
